// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import constants from "@store/constants";

export function getCurrentCustomerType(state: ApplicationState) {
    return getCurrentBillToState(state).value?.properties.customerType;
}

export function getIsB2BCustomer(state: ApplicationState) {
    return getCurrentCustomerType(state) === constants.customerType.b2b;
}
